import { render, staticRenderFns } from "./dialog-time-period.vue?vue&type=template&id=28311e2b&scoped=true"
import script from "./dialog-time-period.vue?vue&type=script&lang=js"
export * from "./dialog-time-period.vue?vue&type=script&lang=js"
import style0 from "./dialog-time-period.vue?vue&type=style&index=0&id=28311e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28311e2b",
  null
  
)

export default component.exports